import useSWRMutation from "swr/mutation";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { ServicesURL } from "@utils/utilsApi";

interface UseDeleteLearningObjectArgs {
  corporateId: string;
}

interface DeleteLearningObjectResponse {
  warns: string[];
  errors: string[];
  parents: {
    type: "PATH" | "COURSE";
    id: number;
  }[];
}

export const useDeleteLearningObject = ({
  corporateId,
}: UseDeleteLearningObjectArgs) => {
  const { trigger, isMutating } = useSWRMutation<
    DeleteLearningObjectResponse,
    Error,
    string,
    { learningObjectId: number; dryrun: boolean }
  >(
    ServicesURL.deleteLearningObject,
    async (
      _key: string,
      { arg }: { arg: { learningObjectId: number; dryrun: boolean } },
    ) => {
      const url = ServicesURL.deleteLearningObject
        .replace(":corporateId", corporateId)
        .replace(":learningObjectId", String(arg.learningObjectId));
      return fetcher(url, MethodType.DELETE, { dryrun: arg.dryrun });
    },
  );

  return {
    deleteLearningObject: (learningObjectId: number, dryrun: boolean) =>
      trigger({ learningObjectId, dryrun }),
    isDeleting: isMutating,
  };
};
